export default __webpack_public_path__ + "static/media/thin-white-cross.91d5bb10.svg";